/* MYTOUCHI XP — příběh aplikačního centra (časově řízená smyčka, od 22. 10. 2026 už ne scrollem – plynulé i na slabších zařízeních) + interaktivní bannery */
(() => {
  const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
  const lin = (p, a, b) => clamp((p - a) / (b - a));
  const ease = x => 1 - Math.pow(1 - clamp(x), 3);
  const io = x => { x = clamp(x); return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
  const mix = (a, b, t) => a + (b - a) * t;
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const motionOff = () => RM.matches || document.documentElement.dataset.mmMotion === 'off';

  // homografie: obdélník W×H → čtyřúhhelník [[x,y]×4] (tl, tr, br, bl)
  function homography(W, H, q) {
    const src = [[0, 0], [W, 0], [W, H], [0, H]], A = [], B = [];
    for (let i = 0; i < 4; i++) {
      const [x, y] = src[i], [u, v] = q[i];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); B.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); B.push(v);
    }
    for (let c = 0; c < 8; c++) { // Gauss
      let m = c; for (let r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[m][c])) m = r;
      [A[c], A[m]] = [A[m], A[c]]; [B[c], B[m]] = [B[m], B[c]];
      for (let r = 0; r < 8; r++) if (r !== c) { const f = A[r][c] / A[c][c]; for (let k = c; k < 8; k++) A[r][k] -= f * A[c][k]; B[r] -= f * B[c]; }
    }
    const h = B.map((b, i) => b / A[i][i]);
    return { h, css: `matrix3d(${h[0]},${h[3]},0,${h[6]},${h[1]},${h[4]},0,${h[7]},0,0,1,0,${h[2]},${h[5]},0,1)`,
      map: (x, y) => { const w = h[6] * x + h[7] * y + 1; return [(h[0] * x + h[1] * y + h[2]) / w, (h[3] * x + h[4] * y + h[5]) / w]; } };
  }
  const parseQuad = s => s.trim().split(/\s+/).map(p => p.split(',').map(Number));

  // ---------- příběh ----------
  function story(root) {
    if(root.hasAttribute('data-f1-story-video'))return;
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const stage = root.querySelector('[data-mxs-stage]'), track = root.querySelector('.mxs-track');
    const shots = { hero: root.querySelector('[data-mxs-shot="hero"]'), top: root.querySelector('[data-mxs-shot="top"]') };
    const quads = { hero: parseQuad(shots.hero.dataset.quad), top: parseQuad(shots.top.dataset.quad) };
    const screen = root.querySelector('[data-mxs-screen]');
    const tiles = [...root.querySelectorAll('.mxs-tile')], files = [...root.querySelectorAll('.mxs-files span')];
    const detail = root.querySelector('.mxs-detail'), idle = root.querySelector('.mxs-idle'), hello = root.querySelector('.mxs-hello');
    const wall = root.querySelector('.mxs-wall'), touch = root.querySelector('.mxs-touch'), lines = [...root.querySelectorAll('.mxs-lines i')];
    const steps = [...root.querySelectorAll('[data-mxs-step]')];
    // Keep each UI on its measured camera plane; crossfade complete photographed layers.
    const screenTop = screen.cloneNode(true);shots.hero.append(screen);shots.top.append(screenTop);
    const originals=[...screen.querySelectorAll('*')],copies=[...screenTop.querySelectorAll('*')];let flightHm;
    const SW = 1600, SH = 900, TW = 330, TH = 270, BASE = innerWidth < 990 ? 1.28 : 1.34, TOPS = 1.18;
    let P = 0, target = 0, visible = false, raf = 0, last = 0, W = 0, H = 0, statik = motionOff(), cycles = 0, hold = 0;
    const DUR = 26; // s na celou smyčku (4 kapitoly)
    root.classList.toggle('is-static', statik); root.dataset.step = '';

    const slot = (i, mode) => mode === 'lib' ? [96 + i * 360, 520, .78] : [84 + i * 366, 470, 1];
    function shotXf(name, p) { // měřítko a průhlednost fotografie podle P
      const inn = io(lin(p, .98, 1.02)), out = io(lin(p, 3.08, 3.12));
      if (name === 'hero') { const zIn = inn * (1 - out), o = 1 - inn + out * 1; return { s: BASE * (1 + .28 * zIn), o: clamp(o) }; }
      const vis = inn * (1 - out); return { s: TOPS * (.9 + .1 * inn + .12 * out), o: vis };
    }
    const xfPoint = ([x, y], s) => { const ox = .5 * W, oy = .45 * H; return [ox + (x * W - ox) * s, oy + (y * H - oy) * s]; };

    function render(t) {
      const p = P;
      const hx = shotXf('hero', p), tx = shotXf('top', p);
      shots.hero.style.transform = `scale(${hx.s})`; shots.hero.style.opacity = hx.o;
      shots.top.style.transform = `scale(${tx.s})`; shots.top.style.opacity = Math.max(.0001,tx.o);
      // čtyřúhhelník displeje: plynule mezi fotkami
      const Hm = flightHm;

      // displej se rozsvítí
      screen.style.opacity = cycles ? 1 : .35 + .65 * ease(lin(p, 0, .25));
      wall.style.transform = `translate(${Math.sin(t / 4200) * 3}%, ${Math.cos(t / 5200) * 3}%) scale(1.04)`;
      hello.style.opacity = ease(lin(p, 1, 1.35)) * (1 - ease(lin(p, 2.45, 2.6)));
      hello.style.transform = `translateY(${(1 - ease(lin(p, 1, 1.35))) * 30}px)`;

      // soubory letí z okraje do knihovny (krok 1)
      files.forEach((f, i) => {
        const a = .08 + i * .1, b = a + .42, f0 = lin(p, a, b), e = io(f0);
        const sx = W * (1.02 - (i % 2) * .05), sy = H * (.18 + i * .2);
        const [lx, ly, ls] = slot(i, 'lib'); const [ex, ey] = Hm.map(lx + TW * ls / 2, ly + TH * ls / 2);
        const cx = mix(sx, ex, e) - 60 * Math.sin(e * Math.PI), cy = mix(sy, ey, e) - 70 * Math.sin(e * Math.PI);
        f.style.opacity = f0 <= 0 || f0 >= 1 ? 0 : Math.min(1, f0 * 5, (1 - f0) * 4);
        f.style.transform = `translate(${cx}px, ${cy}px) translate(-50%,-50%) scale(${mix(1, .45, e)}) rotate(${(1 - e) * (i % 2 ? 6 : -6)}deg)`;
      });

      // dlaždice: knihovna → plocha → přetažení
      tiles.forEach((el, i) => {
        const appear = ease(lin(p, .4 + i * .1, .55 + i * .1));
        const toHome = io(lin(p, 1.05 + i * .05, 1.45 + i * .05));
        let [x0, y0, s0] = slot(i, 'lib'), [x1, y1, s1] = slot(i, 'home');
        // přetažení: dlaždice 3 ↔ 2
        const drag = io(lin(p, 1.55, 1.9));
        if (i === 3) { const [x2, y2] = slot(2, 'home'); x1 = mix(x1, x2, drag); y1 = y1 - 40 * Math.sin(drag * Math.PI); }
        if (i === 2) { const [x3] = slot(3, 'home'); x1 = mix(x1, x3, drag); }
        const lift = i === 3 ? Math.sin(drag * Math.PI) : 0;
        const x = mix(x0, x1, toHome), y = mix(y0, y1, toHome), s = mix(s0, s1, toHome) * (1 + .06 * lift);
        const away = (i === 0 ? ease(lin(p, 2.44, 2.5)) : ease(lin(p, 2.42, 2.6))) + ease(lin(p, 2.95, 3.2));
        el.style.opacity = appear * (1 - clamp(away));
        el.style.transform = `translate(${x}px, ${y + (1 - appear) * 40}px) scale(${s * (.9 + .1 * appear)})`;
        el.style.zIndex = i === 3 ? 2 : 1;
      });

      // dotyk: táhne dlaždici, pak ťukne na „Vaše služby“
      const [d3x, d3y] = slot(3, 'home'), [d2x] = slot(2, 'home'), drag = io(lin(p, 1.55, 1.9));
      const tap = lin(p, 2.12, 2.42), [t0x, t0y] = slot(0, 'home');
      let ux, uy, uo = 0, ur = 1;
      if (p < 2) { ux = mix(d3x, d2x, drag) + TW * .62; uy = d3y + TH * .55 - 40 * Math.sin(drag * Math.PI); uo = ease(lin(p, 1.45, 1.55)) * (1 - ease(lin(p, 1.9, 2))); }
      else { const e = io(lin(p, 2, 2.2)); ux = mix(d2x + TW * .62, t0x + TW * .55, e); uy = mix(d3y + TH * .55, t0y + TH * .55, e); uo = ease(lin(p, 2, 2.08)) * (1 - ease(lin(p, 2.42, 2.52))); ur = 1 + 2.4 * tap; }
      touch.style.opacity = uo; touch.style.transform = `translate(${ux}px, ${uy}px) scale(${1 - .12 * Math.sin(tap * Math.PI)})`; touch.style.setProperty('--r', ur.toFixed(3));

      // detail se otevře z dlaždice
      const open = io(lin(p, 2.4, 2.75)), close = ease(lin(p, 2.95, 3.15));
      const [ox, oy] = slot(0, 'home');
      detail.style.opacity = (open > 0 ? 1 : 0) * (1 - close);
      detail.style.transform = `translate(${mix(ox, 60, open)}px, ${mix(oy, 110, open)}px) scale(${mix(TW / 1480, 1, open)}, ${mix(TH / 740, 1, open)})`;
      detail.style.setProperty('--in', ease(lin(open, .55, 1)).toFixed(3));
      lines.forEach((l, i) => l.style.setProperty('--w', (ease(lin(p, 2.6 + i * .07, 2.85 + i * .07)) * [1, .82, .64][i]).toFixed(3)));

      // klidový režim
      const id = ease(lin(p, 3.05, 3.4)) * (1 - ease(lin(p, 3.86, 3.99))); idle.style.opacity = id;
      
      idle.style.setProperty('--pulse', ((t / 1600) % 1).toFixed(3));

      // kapitoly
      const cur = Math.min(3, Math.floor(p + .02));
      if (root.dataset.step !== String(cur)) { root.dataset.step = cur; steps.forEach((s, i) => { s.classList.toggle('is-active', i === cur); s.querySelector('button').setAttribute('aria-current', i === cur ? 'step' : 'false'); }); }
      steps.forEach((s, i) => s.style.setProperty('--p', clamp(p - i).toFixed(3)));
      originals.forEach((el,i)=>{if(copies[i].style.cssText!==el.style.cssText)copies[i].style.cssText=el.style.cssText});screenTop.style.opacity=screen.style.opacity;
    }

    function measure() { W = stage.clientWidth; H = stage.clientHeight;screen.style.transform=homography(SW,SH,quads.hero.map(([x,y])=>[x*W,y*H])).css;screenTop.style.transform=homography(SW,SH,quads.top.map(([x,y])=>[x*W,y*H])).css;flightHm=homography(SW,SH,quads.hero.map(c=>xfPoint(c,BASE))); }
    function loop(t) {
      raf = 0; if (!visible || statik || document.hidden) return;
      const dt = Math.min(.25, (t - (last || t)) / 1000); last = t;
      if (hold > 0) hold -= dt; else { P += dt * 4 / DUR; if (P >= 4) { P -= 4; cycles++; } }
      render(t); raf = requestAnimationFrame(loop);
    }
    const kick = () => { if (!raf && visible && !statik && !document.hidden) { last = 0; raf = requestAnimationFrame(loop); } };
    new IntersectionObserver(es => { visible = es[0].isIntersecting; if (visible) { measure(); kick(); } }, { rootMargin: '0px 0px -10% 0px' }).observe(stage);
    new ResizeObserver(() => { measure(); render(performance.now()); }).observe(stage);
    document.addEventListener('visibilitychange', () => { last = 0;if(raf)cancelAnimationFrame(raf);raf=0;kick(); });
    // kapitoly: klik skočí na začátek kapitoly, smyčka pak běží dál
    steps.forEach((s, i) => s.querySelector('button').addEventListener('click', () => {
      P = statik ? i + .78 : i + .02; hold = statik ? 0 : .4; if (i) cycles = Math.max(cycles, 1); render(performance.now());
    }));
    const sync = () => { statik = motionOff(); root.classList.toggle('is-static', statik); if (statik) { P = Math.floor(P) + .78; render(performance.now()); } kick(); };
    RM.addEventListener('change', sync); document.addEventListener('mytouchi:motion', sync);new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['data-mm-motion']});
    if (statik) P = .78;
    root.__storySeek=seconds=>{statik=true;if(raf)cancelAnimationFrame(raf);raf=0;P=(seconds%26)*4/26;cycles=1;measure();render(seconds*1000)};
    measure(); render(0);
  }

  // ---------- interaktivní bannery ----------
  function banner(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const tabs = [...root.querySelectorAll('[data-mxb-tab]')], panels = [...root.querySelectorAll('[data-mxb-panel]')];
    function select(i, focus) {
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', k === i); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach((p, k) => { p.hidden = k !== i; if (k === i) setup(p); });
      if (focus) tabs[i].focus();
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', e => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (d) { e.preventDefault(); select((i + d + tabs.length) % tabs.length, true); } });
    });
    function setup(panel) {
      if (panel.dataset.ready) return; panel.dataset.ready = '1';
      const stage = panel.querySelector('[data-mxb-stage]'), frames = [...panel.querySelectorAll('.mxb-frame')], spots = panel.querySelector('[data-mxb-spots]'), range = panel.querySelector('.mxb-range');
      const N = frames.length - 1; let a = 1, target = 1, raf = 0, drag = null, touched = false, visible = false, stageW=stage.clientWidth;new ResizeObserver(()=>stageW=stage.clientWidth).observe(stage);new IntersectionObserver(es=>{visible=es[0].isIntersecting;if(!visible&&raf){cancelAnimationFrame(raf);raf=0}},{threshold:.05}).observe(stage);
      const load = () => frames.forEach(f => { if (f.dataset.src) { f.src = f.dataset.src; delete f.dataset.src; } });
      function draw() {
        frames.forEach((f, i) => {
          const d = a - i, w = clamp(1 - Math.abs(d));
          f.style.opacity = w.toFixed(3);
          // jemný pohyb ve směru otáčení → dojem plynulé rotace mezi snímky
          f.style.transform = `scale(1.32) translateX(${(-d * 2.2).toFixed(2)}%)`;
        });
        spots.classList.toggle('is-off', Math.abs(a - 1) > .12);
        range.value = a.toFixed(2);
      }
      function tick() { raf = 0; if(!visible||document.hidden)return;const d = target - a; a += Math.abs(d) < .002 ? d : d * .18; draw(); if (a !== target) raf = requestAnimationFrame(tick); }
      const go = v => { target = clamp(v, 0, N);if(motionOff()||!visible||document.hidden){if(raf)cancelAnimationFrame(raf);raf=0;a=target;draw();return}if (!raf) raf = requestAnimationFrame(tick); };
      const touch = () => { if (!touched) { touched = true; stage.classList.add('is-touched'); load(); } };
      stage.addEventListener('pointerdown', e => { if (e.target.closest('.mxb-spot') || e.target === range) return; touch(); drag = { x: e.clientX, a: target, id: e.pointerId }; stage.setPointerCapture(e.pointerId); stage.classList.add('is-drag'); });
      stage.addEventListener('pointermove', e => {
        if (!drag) return; go(drag.a - (e.clientX - drag.x) / (stageW * .32));
      });
      const end = () => { if (!drag) return; drag = null; stage.classList.remove('is-drag'); go(Math.round(target)); };
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
      stage.addEventListener('keydown', e => { const d = e.key === 'ArrowRight' ? -1 : e.key === 'ArrowLeft' ? 1 : 0; if (d) { e.preventDefault(); touch(); go(Math.round(target) + d); } });
      range.addEventListener('input', () => { touch(); target = a = +range.value; draw(); });
      panel.querySelectorAll('.mxb-spot').forEach(b => b.classList.toggle('is-left', parseFloat(b.style.getPropertyValue('--x')) > .5));
      panel.querySelectorAll('.mxb-spot').forEach(b => b.addEventListener('click', () => { const o = b.getAttribute('aria-expanded') === 'true'; panel.querySelectorAll('.mxb-spot').forEach(x => x.setAttribute('aria-expanded', 'false')); b.setAttribute('aria-expanded', String(!o)); }));
      // nápověda: jednou se produkt sám pootočí, když banner poprvé uvidíte
      new IntersectionObserver((es, ob) => { if (!es[0].isIntersecting) return; ob.disconnect(); load(); if (motionOff()) return;
        setTimeout(() => { if (!touched&&!motionOff()&&visible&&!document.hidden) go(2); }, 700); setTimeout(() => { if (!touched&&!motionOff()&&visible&&!document.hidden) go(1); }, 1900); }, { threshold: .55 }).observe(stage);
      const syncMotion=()=>{if(motionOff()){if(raf)cancelAnimationFrame(raf);raf=0;target=a=1;draw()}};RM.addEventListener('change',syncMotion);document.addEventListener('mytouchi:motion',syncMotion);new MutationObserver(syncMotion).observe(document.documentElement,{attributes:true,attributeFilter:['data-mm-motion']});
      draw();
    }
    select(0);
  }
  window.MytouchiXPBanner = banner;

  function init(scope) { scope.querySelectorAll('[data-mxs]').forEach(story); scope.querySelectorAll('[data-mxb]').forEach(el => window.MytouchiXPBanner && window.MytouchiXPBanner(el)); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
